var cov_2h6n27rfpm = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/defaultProps.ts",
      hash = "5d2d6fa13d1add29cea1299aa3309037e906adef",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/defaultProps.ts",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 14,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

export var defaultProps = (cov_2h6n27rfpm.s[0]++, {
  className: '',
  size: 'default',
  style: {},
  type: 'default'
});